const CART_SESSION_KEY = "openstore_cart_session";

function generateId(): string {
  return crypto.randomUUID();
}

export function getCartSessionId(): string {
  let sessionId = localStorage.getItem(CART_SESSION_KEY);
  if (!sessionId) {
    sessionId = generateId();
    localStorage.setItem(CART_SESSION_KEY, sessionId);
  }
  return sessionId;
}

export const SIDE_CART_OPEN_EVENT = "nexus:open-side-cart";

export function openSideCart(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SIDE_CART_OPEN_EVENT));
}
